import { RegistrationActionTypes } from './types'

export const REGISTRATION_START = 'REGISTRATION/START'
export const REGISTRATION_SUCCESS = 'REGISTRATION/SUCCESS'
export const REGISTRATION_ERROR = 'REGISTRATION/ERROR'

export const registrationStart = (): RegistrationActionTypes => {
  return { type: REGISTRATION_START }
}

export const registrationSuccess = (): RegistrationActionTypes => {
  return { type: REGISTRATION_SUCCESS }
}
export const registrationError = (): RegistrationActionTypes => {
  return { type: REGISTRATION_ERROR }
}
